import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useProfessionalViewModel } from '../../view-model/professional/professional-view-model';
import { getTimeZoneOptions } from '../../utils/timezone';

/**
 * Composant de sélection de fuseau horaire
 * Utilise date-fns-tz pour générer dynamiquement les options avec les décalages horaires corrects
 */

/**
 * Composant de sélection de fuseau horaire
 */
const TimezoneSelect: React.FC = observer(() => {
  const professionalViewModel = useProfessionalViewModel();
  const [timezones, setTimezones] = useState<{ value: string; label: string }[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    // Charger les fuseaux horaires avec les décalages horaires dynamiques
    setTimezones(getTimeZoneOptions());
    setIsLoading(false);
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    professionalViewModel.setTimeZone(e.target.value);
  };

  if (isLoading) {
    return <div>Chargement des fuseaux horaires...</div>;
  }

  return (
    <div className="timezone-select-container">
      <label htmlFor="timezone-select" className="block text-sm font-medium mb-1">
        Fuseau horaire
      </label>
      <select
        id="timezone-select"
        className="w-full px-3 py-2 border border-gray-300 dark:border-gray-700 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100"
        value={professionalViewModel.timeZone}
        onChange={handleChange}
      >
        {timezones.map((timezone) => (
          <option key={timezone.value} value={timezone.value}>
            {timezone.label}
          </option>
        ))}
      </select>
      <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
        Le fuseau horaire est utilisé pour afficher correctement les dates et heures de vos rendez-vous.
      </p>
    </div>
  );
});

export default TimezoneSelect;
